// Capture fbclid on ad landing page
const urlParams = new URLSearchParams(window.location.search);
const fbclid = urlParams.get('fbclid');
if (fbclid) {
  localStorage.setItem('meta_click_id', fbclid);
}
